import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NavigationModel } from '../../models/navigation/navigation.model';

export const selectNavigation = createSelector(
  createFeatureSelector('navigation'),
  (navigation: NavigationModel) => {
    return navigation;
  },
);
